import Vue from "vue"
import VueRouter from "vue-router"
import auth from "../components/helper/auth"

Vue.use(VueRouter)

const routes = [
    {
        path: "/logout",
        beforeEnter(to, from, next) {
            auth.logout()
            next("/login")
        }
    },
    {
        path: "/login:auth?",
        name: "Login",
        component: () => import(/* webpackChunkName: "about" */ "../views/Login.vue")
    },
    // {
    //   path: '/settings',
    //   name: 'Settings',
    //   component: () => import(/* webpackChunkName: "about" */ '../views/AdminPanel.vue'),
    //   beforeEnter: requireAuth,
    // },
    {
        path: "*",
        name: "AdminDashboard",
        component: () => import(/* webpackChunkName: "about" */ "../views/Dashboard.vue"),
        beforeEnter: requireAuth
    },
    {
        path: "/admin/monitoring",
        name: "AdminMonitoring",
        component: () => import(/* webpackChunkName: "about" */ "../views/admin/Monitoring.vue"),
        beforeEnter: requireAuth
    },
    {
        path: "/admin/user",
        name: "AdminUser",
        component: () => import(/* webpackChunkName: "about" */ "../views/admin/User.vue"),
        beforeEnter: requireAuth
    },
    {
        path: "/admin/panel",
        name: "AdminPanel",
        component: () => import(/* webpackChunkName: "about" */ "../views/admin/Panel.vue"),
        beforeEnter: requireAuth
    },
    {
        path: "/admin/credits",
        name: "AdminCredits",
        component: () => import(/* webpackChunkName: "about" */ "../views/admin/credits/Credits.vue"),
        beforeEnter: requireAuth
    },
    {
        path: "/admin/registrations",
        name: "AdminRegistrations",
        component: () => import(/* webpackChunkName: "about" */ "../views/admin/companies/Registrations.vue"),
        beforeEnter: requireAuth
    },
    {
        path: "/admin/companies",
        name: "AdminCompany",
        component: () => import(/* webpackChunkName: "about" */ "../views/admin/companies/CompaniesDash.vue"),
        beforeEnter: requireAuth,
        children: [
            {
                path: ":id/edit",
                component: () => import(/* webpackChunkName: "about" */ "../views/admin/companies/CompanyEdit.vue"),
                beforeEnter: requireAuth
            }
        ]
    }
]

function requireAuth(to, from, next) {
    next()
    auth.loggedIn().then((response) => {
        if (!response) {
            // //console.log()
            delete localStorage.token
            delete localStorage.user
            delete localStorage.id
            delete localStorage.company_id
            delete localStorage.plan
            next({
                path: "/login",
                query: { redirect: to.fullPath }
            })
        }
    })
}

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
})

export default router
